export const LOADING_CAPACITACION_LISTADO = "LOADING_CAPACITACION_LISTADO";
export const SAVE_LOADING_CAPACITACION = "SAVE_LOADING_CAPACITACION";
export const GET_CAPACITACION_LISTADO = "GET_CAPACITACION_LISTADO";

export const LOADING_CAPACITACION = "LOADING_CAPACITACION";
export const GET_CAPACITACION = "GET_CAPACITACION";

export const LOADING_BLOQUE = "LOADING_BLOQUE";
export const GET_BLOQUE = "GET_BLOQUE";

export const LOADING_BLOQUE_ACTUAL = "LOADING_BLOQUE_ACTUAL";
export const GET_BLOQUE_ACTUAL = "GET_BLOQUE_ACTUAL";

export const LOADING_BLOQUE_ANTERIOR_ANTERIOR =
  "LOADING_BLOQUE_ANTERIOR_ANTERIOR";
export const GET_BLOQUE_ANTERIOR_ANTERIOR = "GET_BLOQUE_ANTERIOR_ANTERIOR";

export const LOADING_ESTADO_ACTIVIDAD = "LOADING_ESTADO_ACTIVIDAD";

export const LOADING_SUBIR_ARCHIVO = "LOADING_SUBIR_ARCHIVO";
export const CORREO_FAIL = "CORREO_FAIL";

// Mostrar Bienvenida
export const LOADING_VENTANA_BIENVENIDA = "LOADING_VENTANA_BIENVENIDA";
export const GET_VENTANA_BIENVENIDA = "GET_VENTANA_BIENVENIDA";
